import * as React from 'react';
import {Basic} from './Basic.story';

const basic = {
  rendered: <Basic />,
  source: `<Table>
  <TableHead>
    <TableRow>
      <TableHeaderCell>Charge type</TableHeaderCell>
      <TableHeaderCell>Amount</TableHeaderCell>
    </TableRow>
  </TableHead>
  <TableBody>
    <TableRow>
      <TableCell>Setup fee</TableCell>
      <TableCell>$95.00</TableCell>
    </TableRow>
    <TableRow>
      <TableCell>Maintenance fee</TableCell>
      <TableCell>$50.45</TableCell>
    </TableRow>
    <TableRow>
      <TableCell>Extra storage space (per GB)</TableCell>
      <TableCell>$5.95</TableCell>
    </TableRow>
    <TableRow>
      <TableCell>Premium features</TableCell>
      <TableCell>$109.00</TableCell>
    </TableRow>
  </TableBody>
</Table>`,
};

export const TableExamples = {
  basic,
};
